var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1996_41756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.151611C6.17348 0.151611 3.06024 3.26462 3.06024 7.09138C3.06024 9.63739 4.47399 11.9858 6.6988 13.1996V14.6336C6.6988 15.0328 7.02243 15.3565 7.42169 15.3565H12.5545C12.9537 15.3565 13.2774 15.0329 13.2774 14.6336V13.2015C15.5169 11.9926 16.9398 9.64321 16.9398 7.09142C16.9398 3.26462 13.8265 0.151611 10 0.151611ZM12.2547 12.0962C11.9969 12.2135 11.8313 12.4706 11.8313 12.754V13.9107H8.14458V12.754C8.14458 12.4718 7.98024 12.2152 7.72411 12.0974C5.76919 11.1969 4.50602 9.23185 4.50602 7.09138C4.50602 4.06196 6.97059 1.59739 10 1.59739C13.0294 1.59739 15.494 4.06196 15.494 7.09138C15.494 9.23524 14.2224 11.1998 12.2547 12.0962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.3203H7.99999C7.60073 16.3203 7.2771 16.6439 7.2771 17.0432C7.2771 17.4425 7.60069 17.7661 7.99999 17.7661H12C12.3992 17.7661 12.7229 17.4425 12.7229 17.0432C12.7229 16.6439 12.3992 16.3203 12 16.3203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8434 18.7058H9.15667C8.75741 18.7058 8.43378 19.0294 8.43378 19.4287C8.43378 19.828 8.75741 20.1516 9.15667 20.1516H10.8434C11.2427 20.1516 11.5663 19.828 11.5663 19.4287C11.5663 19.0294 11.2427 18.7058 10.8434 18.7058Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1996_41756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.151611)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.5c9d0b91347f9503bd3baab9d5b0f556.svg";
export { ForwardRef as ReactComponent };